// extracted by mini-css-extract-plugin
export default {"modal":"pAbCVv","mobile":"wZ503T","modalContent":"sf_t8i","header":"n9QInz","subtitle":"CM1EtP","content":"hiSMOQ","buttonContainer":"kZlV0I","button":"hCiSqf"};